// TEMPORARY: controls whether the guided onboarding wizard opens for first-time users.
// Set to false to disable it (users go straight to the app). Set back to true to re-enable.
export const ONBOARDING_ENABLED = false;
